export const PAYMENT_ID = 'payment_id';
export const PAYMENT_INTENT_ID = 'payment_intent_id';
export const EMBEDDED_PARAMS = '?mode=APP&src=AMZ';
